:host {
  display: block;
}

.biel-feedback-container {
  display: flex;
  align-items: center;
  padding: 8px 0 0;
}

.biel-feedback-reaction {
  display: flex;
  gap: 5px;
}

.biel-feedback-btn {
  background: var(--biel-feedback-bg-color);
  color: var(--biel-feedback-text-color);
  border: none;
  cursor: pointer;
  padding: 4px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.biel-feedback-btn:hover {
  background: var(--biel-feedback-bg-hover-color);
}

.active, .active:hover {
  background: var(--biel-feedback-background-selected-color);
  color: var(--biel-feedback-text-selected-color);
  transition: background-color 0.3s ease;
}